import { html, View } from 'rune-ts';
import klass from './DetachedTabView.module.scss';
import { classes } from '@services/MarppleShop/shared/util';
import { font } from '@services/MarppleShop/shared/typography';
import { IconsBasicArrowRightM } from '@services/MarppleShop/shared/components/atoms/Icon';

export type TProps =
  | {
      state: 'On' | 'Off';
      thumbnail: 'On' | 'Off';
      size: 'S';
      text: string;
    }
  | {
      state: 'On' | 'Off';
      thumbnail: 'Off';
      size: 'M';
      text: string;
    }
  | {
      state: 'On' | 'Off';
      thumbnail: 'On' | 'Off';
      size: 'L';
      text: string;
    };

export class DetachedTabView extends View<TProps> {
  protected override template(props: TProps) {
    if (props.thumbnail === 'On' || props.size === 'L') {
      throw new Error();
    }

    const { size, state, text } = props;

    return html`<span
      class="${classes(
        klass.tab,
        {
          [klass.state_on]: state === 'On',
          [klass.state_off]: state === 'Off',
        },
        {
          [klass.size_s]: size === 'S',
          [font('14_medium')]: size === 'S',
          [klass.size_m]: size === 'M',
          [font('16_medium')]: size === 'M',
        },
      )}"
      >${text}

      <span class="${klass.icons_basic}">${IconsBasicArrowRightM}</span>
    </span>`;
  }
}
